import { useMemo } from "react";
import withResponsiveHOC from "/components/enhancements/responsive-hoc/responsive-hoc-component";
import { DEV_LIGHTER_TINT_01, DEV_LIGHTER_TINT_01_COLOR_NAME } from "styles/color-consts";
import UseCasesTabsDesktopComponent from "./use-cases-tabs-desktop-component/use-cases-tabs-desktop-component.js";
import UseCasesTabsMobileComponent from "./use-cases-tabs-mobile-component/use-cases-tabs-mobile-component.js";
import DefaultProps from "./default-props";

const COLOR_TO_CLASS_NAME = {
  [DEV_LIGHTER_TINT_01]: DEV_LIGHTER_TINT_01_COLOR_NAME
};

const UseCasesTabsComponent = ({ buttonsColor, ...rest }) => {
  const UseCasesTabsResponsiveComponent = useMemo(
    () => withResponsiveHOC(UseCasesTabsDesktopComponent, UseCasesTabsMobileComponent),
    []
  );

  return <UseCasesTabsResponsiveComponent {...rest} buttonsColor={COLOR_TO_CLASS_NAME[buttonsColor] || buttonsColor} />;
};

export default UseCasesTabsComponent;

UseCasesTabsComponent.defaultProps = DefaultProps;
